import React from 'react';
import { Desktop, Mobile } from '../utils/breakpoint';

import {
  ExperienceCollectiveCarousel,
  ExperienceCollectiveCarouselProps,
} from './ExperienceCollectiveCarousel';
import { ExperienceCollectiveSlider } from './ExperienceCollectiveSlider';

export const ExperienceCollectiveReviews: React.FC<ExperienceCollectiveCarouselProps> =
  ({ title, reviews, ...rest }) => {
    return (
      <>
        <Desktop>
          <ExperienceCollectiveCarousel
            title={title}
            reviews={reviews}
            {...rest}
          />
        </Desktop>

        <Mobile>
          <ExperienceCollectiveSlider title={title} reviews={reviews} />
        </Mobile>
      </>
    );
  };
